/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VelkominRouteImport } from './routes/velkomin'
import { Route as TodosRouteImport } from './routes/todos'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GleymtLykilordRouteImport } from './routes/gleymt-lykilord'
import { Route as FarsimiRouteImport } from './routes/farsimi'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerkfaeriSpalikanOrkunotkunRouteImport } from './routes/verkfaeri.spalikan-orkunotkun'
import { Route as VerkfaeriMarkadurinnRouteImport } from './routes/verkfaeri.markadurinn'
import { Route as VerkfaeriAtomikaReiknivelRouteImport } from './routes/verkfaeri.atomika-reiknivel'
import { Route as VerkfaeriAtomikaMaelabordRouteImport } from './routes/verkfaeri.atomika-maelabord'
import { Route as VerkfaeriAtomikaHeimasidaRouteImport } from './routes/verkfaeri.atomika-heimasida'
import { Route as AdminNotendurRouteImport } from './routes/admin.notendur'

const VelkominRoute = VelkominRouteImport.update({
  id: '/velkomin',
  path: '/velkomin',
  getParentRoute: () => rootRouteImport,
} as any)
const TodosRoute = TodosRouteImport.update({
  id: '/todos',
  path: '/todos',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GleymtLykilordRoute = GleymtLykilordRouteImport.update({
  id: '/gleymt-lykilord',
  path: '/gleymt-lykilord',
  getParentRoute: () => rootRouteImport,
} as any)
const FarsimiRoute = FarsimiRouteImport.update({
  id: '/farsimi',
  path: '/farsimi',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerkfaeriSpalikanOrkunotkunRoute =
  VerkfaeriSpalikanOrkunotkunRouteImport.update({
    id: '/verkfaeri/spalikan-orkunotkun',
    path: '/verkfaeri/spalikan-orkunotkun',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerkfaeriMarkadurinnRoute = VerkfaeriMarkadurinnRouteImport.update({
  id: '/verkfaeri/markadurinn',
  path: '/verkfaeri/markadurinn',
  getParentRoute: () => rootRouteImport,
} as any)
const VerkfaeriAtomikaReiknivelRoute =
  VerkfaeriAtomikaReiknivelRouteImport.update({
    id: '/verkfaeri/atomika-reiknivel',
    path: '/verkfaeri/atomika-reiknivel',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerkfaeriAtomikaMaelabordRoute =
  VerkfaeriAtomikaMaelabordRouteImport.update({
    id: '/verkfaeri/atomika-maelabord',
    path: '/verkfaeri/atomika-maelabord',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerkfaeriAtomikaHeimasidaRoute =
  VerkfaeriAtomikaHeimasidaRouteImport.update({
    id: '/verkfaeri/atomika-heimasida',
    path: '/verkfaeri/atomika-heimasida',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminNotendurRoute = AdminNotendurRouteImport.update({
  id: '/admin/notendur',
  path: '/admin/notendur',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/farsimi': typeof FarsimiRoute
  '/gleymt-lykilord': typeof GleymtLykilordRoute
  '/login': typeof LoginRoute
  '/todos': typeof TodosRoute
  '/velkomin': typeof VelkominRoute
  '/admin/notendur': typeof AdminNotendurRoute
  '/verkfaeri/atomika-heimasida': typeof VerkfaeriAtomikaHeimasidaRoute
  '/verkfaeri/atomika-maelabord': typeof VerkfaeriAtomikaMaelabordRoute
  '/verkfaeri/atomika-reiknivel': typeof VerkfaeriAtomikaReiknivelRoute
  '/verkfaeri/markadurinn': typeof VerkfaeriMarkadurinnRoute
  '/verkfaeri/spalikan-orkunotkun': typeof VerkfaeriSpalikanOrkunotkunRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/farsimi': typeof FarsimiRoute
  '/gleymt-lykilord': typeof GleymtLykilordRoute
  '/login': typeof LoginRoute
  '/todos': typeof TodosRoute
  '/velkomin': typeof VelkominRoute
  '/admin/notendur': typeof AdminNotendurRoute
  '/verkfaeri/atomika-heimasida': typeof VerkfaeriAtomikaHeimasidaRoute
  '/verkfaeri/atomika-maelabord': typeof VerkfaeriAtomikaMaelabordRoute
  '/verkfaeri/atomika-reiknivel': typeof VerkfaeriAtomikaReiknivelRoute
  '/verkfaeri/markadurinn': typeof VerkfaeriMarkadurinnRoute
  '/verkfaeri/spalikan-orkunotkun': typeof VerkfaeriSpalikanOrkunotkunRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/farsimi': typeof FarsimiRoute
  '/gleymt-lykilord': typeof GleymtLykilordRoute
  '/login': typeof LoginRoute
  '/todos': typeof TodosRoute
  '/velkomin': typeof VelkominRoute
  '/admin/notendur': typeof AdminNotendurRoute
  '/verkfaeri/atomika-heimasida': typeof VerkfaeriAtomikaHeimasidaRoute
  '/verkfaeri/atomika-maelabord': typeof VerkfaeriAtomikaMaelabordRoute
  '/verkfaeri/atomika-reiknivel': typeof VerkfaeriAtomikaReiknivelRoute
  '/verkfaeri/markadurinn': typeof VerkfaeriMarkadurinnRoute
  '/verkfaeri/spalikan-orkunotkun': typeof VerkfaeriSpalikanOrkunotkunRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/farsimi'
    | '/gleymt-lykilord'
    | '/login'
    | '/todos'
    | '/velkomin'
    | '/admin/notendur'
    | '/verkfaeri/atomika-heimasida'
    | '/verkfaeri/atomika-maelabord'
    | '/verkfaeri/atomika-reiknivel'
    | '/verkfaeri/markadurinn'
    | '/verkfaeri/spalikan-orkunotkun'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/farsimi'
    | '/gleymt-lykilord'
    | '/login'
    | '/todos'
    | '/velkomin'
    | '/admin/notendur'
    | '/verkfaeri/atomika-heimasida'
    | '/verkfaeri/atomika-maelabord'
    | '/verkfaeri/atomika-reiknivel'
    | '/verkfaeri/markadurinn'
    | '/verkfaeri/spalikan-orkunotkun'
  id:
    | '__root__'
    | '/'
    | '/farsimi'
    | '/gleymt-lykilord'
    | '/login'
    | '/todos'
    | '/velkomin'
    | '/admin/notendur'
    | '/verkfaeri/atomika-heimasida'
    | '/verkfaeri/atomika-maelabord'
    | '/verkfaeri/atomika-reiknivel'
    | '/verkfaeri/markadurinn'
    | '/verkfaeri/spalikan-orkunotkun'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FarsimiRoute: typeof FarsimiRoute
  GleymtLykilordRoute: typeof GleymtLykilordRoute
  LoginRoute: typeof LoginRoute
  TodosRoute: typeof TodosRoute
  VelkominRoute: typeof VelkominRoute
  AdminNotendurRoute: typeof AdminNotendurRoute
  VerkfaeriAtomikaHeimasidaRoute: typeof VerkfaeriAtomikaHeimasidaRoute
  VerkfaeriAtomikaMaelabordRoute: typeof VerkfaeriAtomikaMaelabordRoute
  VerkfaeriAtomikaReiknivelRoute: typeof VerkfaeriAtomikaReiknivelRoute
  VerkfaeriMarkadurinnRoute: typeof VerkfaeriMarkadurinnRoute
  VerkfaeriSpalikanOrkunotkunRoute: typeof VerkfaeriSpalikanOrkunotkunRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/velkomin': {
      id: '/velkomin'
      path: '/velkomin'
      fullPath: '/velkomin'
      preLoaderRoute: typeof VelkominRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/todos': {
      id: '/todos'
      path: '/todos'
      fullPath: '/todos'
      preLoaderRoute: typeof TodosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gleymt-lykilord': {
      id: '/gleymt-lykilord'
      path: '/gleymt-lykilord'
      fullPath: '/gleymt-lykilord'
      preLoaderRoute: typeof GleymtLykilordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/farsimi': {
      id: '/farsimi'
      path: '/farsimi'
      fullPath: '/farsimi'
      preLoaderRoute: typeof FarsimiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/spalikan-orkunotkun': {
      id: '/verkfaeri/spalikan-orkunotkun'
      path: '/verkfaeri/spalikan-orkunotkun'
      fullPath: '/verkfaeri/spalikan-orkunotkun'
      preLoaderRoute: typeof VerkfaeriSpalikanOrkunotkunRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/markadurinn': {
      id: '/verkfaeri/markadurinn'
      path: '/verkfaeri/markadurinn'
      fullPath: '/verkfaeri/markadurinn'
      preLoaderRoute: typeof VerkfaeriMarkadurinnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/atomika-reiknivel': {
      id: '/verkfaeri/atomika-reiknivel'
      path: '/verkfaeri/atomika-reiknivel'
      fullPath: '/verkfaeri/atomika-reiknivel'
      preLoaderRoute: typeof VerkfaeriAtomikaReiknivelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/atomika-maelabord': {
      id: '/verkfaeri/atomika-maelabord'
      path: '/verkfaeri/atomika-maelabord'
      fullPath: '/verkfaeri/atomika-maelabord'
      preLoaderRoute: typeof VerkfaeriAtomikaMaelabordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkfaeri/atomika-heimasida': {
      id: '/verkfaeri/atomika-heimasida'
      path: '/verkfaeri/atomika-heimasida'
      fullPath: '/verkfaeri/atomika-heimasida'
      preLoaderRoute: typeof VerkfaeriAtomikaHeimasidaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/notendur': {
      id: '/admin/notendur'
      path: '/admin/notendur'
      fullPath: '/admin/notendur'
      preLoaderRoute: typeof AdminNotendurRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FarsimiRoute: FarsimiRoute,
  GleymtLykilordRoute: GleymtLykilordRoute,
  LoginRoute: LoginRoute,
  TodosRoute: TodosRoute,
  VelkominRoute: VelkominRoute,
  AdminNotendurRoute: AdminNotendurRoute,
  VerkfaeriAtomikaHeimasidaRoute: VerkfaeriAtomikaHeimasidaRoute,
  VerkfaeriAtomikaMaelabordRoute: VerkfaeriAtomikaMaelabordRoute,
  VerkfaeriAtomikaReiknivelRoute: VerkfaeriAtomikaReiknivelRoute,
  VerkfaeriMarkadurinnRoute: VerkfaeriMarkadurinnRoute,
  VerkfaeriSpalikanOrkunotkunRoute: VerkfaeriSpalikanOrkunotkunRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
